/* eslint-disable no-unused-vars */
/* ICONS */
import {
  MdSpaceDashboard,
  MdOutlineInventory2,
  MdLocalOffer,
} from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";
import { BsEmojiSmile } from "react-icons/bs";
import { BiCategory } from "react-icons/bi";
import { TbCategoryPlus } from "react-icons/tb";
import { LuTags } from "react-icons/lu";
import { FaInstagram } from "react-icons/fa";
import { RiCoupon2Line } from "react-icons/ri";
import { IoHeadsetOutline } from "react-icons/io5";
import { FaRegMessage } from "react-icons/fa6";
import { IoIosGift } from "react-icons/io";

const navMenu = [
  {
    id: 1,
    link: "/dashboard",
    icon: MdSpaceDashboard,
    name: "Sales Dashboard",
  },
  {
    id: 2,
    link: "/orders",
    icon: FiShoppingCart,
    name: "Orders",
  },
  {
    id: 3,
    link: "/customers",
    icon: BsEmojiSmile,
    name: "Customers",
  },
  {
    id: 4,
    link: "/inventory",
    icon: MdOutlineInventory2,
    name: "Inventory",
    secondary: "/inventory/add-product",
  },
  {
    id: 5,
    link: "/categories",
    icon: BiCategory,
    name: "Categories",
  },
  {
    id: 6,
    link: "/sub-categories",
    icon: TbCategoryPlus,
    name: "Sub-categories",
  },
  {
    id: 7,
    link: "/tags",
    icon: LuTags,
    name: "Tags",
  },
  {
    id: 8,
    link: "/marketing-messages",
    icon: FaRegMessage,
    name: "Marketing Messages",
  },
  {
    id: 9,
    link: "/offers-and-promocodes",
    icon: RiCoupon2Line,
    name: "Offers & Promocodes",
  },
  {
    id: 10,
    link: "/contact-us",
    icon: IoHeadsetOutline,
    name: "Contact Us",
  },
  {
    id: 11,
    link: "/gift-card",
    icon: IoIosGift,
    name: "Gift Card",
  },
  {
    id: 12,
    link: "/offers-leads",
    icon: MdLocalOffer,
    name: "Offers Page",
  },
];

export default navMenu;
